var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    { attrs: { row: "", "justify-center": "" } },
    [
      _c(
        "v-dialog",
        {
          attrs: {
            persistent: "",
            fullscreen: "",
            "hide-overlay": "",
            transition: "dialog-bottom-transition"
          },
          model: {
            value: _vm.dialog,
            callback: function($$v) {
              _vm.dialog = $$v
            },
            expression: "dialog"
          }
        },
        [
          _c(
            "v-card",
            { attrs: { id: "cardDivTV" } },
            [
              _c(
                "v-toolbar",
                { attrs: { dark: "", color: "primary", fixed: "" } },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: { icon: "", dark: "", disabled: _vm.btnBloquear },
                      on: {
                        click: function($event) {
                          !_vm.isEdit
                            ? _vm.closeModal(false)
                            : (_vm.dialogConfirmacionClose = true)
                        }
                      }
                    },
                    [_c("v-icon", [_vm._v("close")])],
                    1
                  ),
                  _c("v-toolbar-title", [
                    _vm._v(
                      _vm._s(
                        _vm.isEdit
                          ? "Editar Reasignación"
                          : _vm.isView
                          ? "Informar Reasignación"
                          : "Ver Detalle Reasignación"
                      )
                    )
                  ]),
                  _c("v-spacer"),
                  _c(
                    "v-toolbar-items",
                    [
                      _vm.isEdit
                        ? _c(
                            "v-btn",
                            {
                              staticClass: "btn-grabar",
                              attrs: {
                                depressed: "",
                                disabled:
                                  !_vm.validForm ||
                                  _vm.btnBloquear ||
                                  _vm.btnBloquearGuardado
                              },
                              on: {
                                click: function($event) {
                                  return _vm.grabarEdicion()
                                }
                              }
                            },
                            [_vm._v("Guardar Cambios")]
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              ),
              _c("br"),
              _c("br"),
              _c("br"),
              _c("div", [
                _c(
                  "div",
                  { staticClass: "cardnew", attrs: { align: "center" } },
                  [
                    _c("br"),
                    _c(
                      "v-flex",
                      { attrs: { md10: "" } },
                      [
                        _c(
                          "v-card",
                          { staticClass: "rounded-card" },
                          [
                            _c(
                              "v-form",
                              {
                                ref: "form",
                                staticClass: "col-md-12",
                                attrs: { "lazy-validation": "" },
                                model: {
                                  value: _vm.validForm,
                                  callback: function($$v) {
                                    _vm.validForm = $$v
                                  },
                                  expression: "validForm"
                                }
                              },
                              [
                                _c(
                                  "v-container",
                                  { attrs: { "grid-list-md": "" } },
                                  [
                                    _c(
                                      "div",
                                      { attrs: { align: "left" } },
                                      [
                                        _c("v-flex", { attrs: { md12: "" } }, [
                                          _c(
                                            "h2",
                                            {
                                              staticClass: "h2_title",
                                              staticStyle: {
                                                "margin-top": "12px !important"
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                        " +
                                                  _vm._s(_vm.getNameModal()) +
                                                  "\n                      "
                                              )
                                            ]
                                          )
                                        ])
                                      ],
                                      1
                                    ),
                                    _c("v-divider"),
                                    _c("br"),
                                    _c(
                                      "v-layout",
                                      { attrs: { wrap: "" } },
                                      [
                                        _c(
                                          "v-flex",
                                          { attrs: { sm6: "", md6: "" } },
                                          [
                                            _c("v-autocomplete", {
                                              attrs: {
                                                clearable: "",
                                                label:
                                                  _vm.formFields.coordinador
                                                    .label,
                                                items: _vm.coordinadores,
                                                "item-text": "coorname",
                                                "item-value": "coorid",
                                                required: true,
                                                disabled: _vm.isView
                                              },
                                              model: {
                                                value:
                                                  _vm.formFields.coordinador
                                                    .value,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.formFields.coordinador,
                                                    "value",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "formFields.coordinador.value"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _c(
                                          "v-flex",
                                          { attrs: { sm6: "", md6: "" } },
                                          [
                                            _c("v-text-field", {
                                              attrs: {
                                                label: _vm.formFields.NDV.label,
                                                required: true,
                                                disabled: _vm.isView
                                              },
                                              model: {
                                                value: _vm.formFields.NDV.value,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.formFields.NDV,
                                                    "value",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "formFields.NDV.value"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _c(
                                          "v-flex",
                                          { attrs: { sm6: "", md6: "" } },
                                          [
                                            _c("v-text-field", {
                                              attrs: {
                                                label: _vm.formFields.EPC.label,
                                                disabled: _vm.isView
                                              },
                                              model: {
                                                value: _vm.formFields.EPC.value,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.formFields.EPC,
                                                    "value",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "formFields.EPC.value"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _c(
                                          "v-flex",
                                          { attrs: { sm6: "", md6: "" } },
                                          [
                                            _c("v-text-field", {
                                              attrs: {
                                                label:
                                                  _vm.formFields.fundamento
                                                    .label,
                                                required: true,
                                                disabled: _vm.isView
                                              },
                                              model: {
                                                value:
                                                  _vm.formFields.fundamento
                                                    .value,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.formFields.fundamento,
                                                    "value",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "formFields.fundamento.value"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _c(
                                          "v-flex",
                                          { attrs: { sm6: "", md6: "" } },
                                          [
                                            _c("v-autocomplete", {
                                              attrs: {
                                                clearable: "",
                                                label:
                                                  _vm.formFields.tecnico.label,
                                                items: _vm.tecnicos,
                                                "item-text": "tecniconame",
                                                "item-value": "tecnicoid",
                                                required: true,
                                                disabled: _vm.isView
                                              },
                                              on: {
                                                change: _vm.loadnumeroSerie
                                              },
                                              model: {
                                                value:
                                                  _vm.formFields.tecnico.value,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.formFields.tecnico,
                                                    "value",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "formFields.tecnico.value"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _c(
                                          "v-flex",
                                          { attrs: { sm6: "", md6: "" } },
                                          [
                                            _c("v-autocomplete", {
                                              attrs: {
                                                clearable: "",
                                                label:
                                                  _vm.formFields.serie.label,
                                                items: _vm.serieNum,
                                                "item-text": "serienumero",
                                                "item-value": "serienumero",
                                                required: true,
                                                disabled: _vm.isView
                                              },
                                              on: { change: _vm.loadDatos },
                                              model: {
                                                value:
                                                  _vm.formFields.serie.value,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.formFields.serie,
                                                    "value",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "formFields.serie.value"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _c(
                                          "v-flex",
                                          { attrs: { sm6: "", md6: "" } },
                                          [
                                            _c("v-autocomplete", {
                                              attrs: {
                                                clearable: "",
                                                label:
                                                  _vm.formFields.tEquipo.label,
                                                items: _vm.tipoeq,
                                                "item-text": "tipoeqname",
                                                "item-value": "tipoeqid",
                                                required: true,
                                                disabled: _vm.isView
                                              },
                                              model: {
                                                value:
                                                  _vm.formFields.tEquipo.value,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.formFields.tEquipo,
                                                    "value",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "formFields.tEquipo.value"
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _c(
                                          "v-flex",
                                          { attrs: { sm6: "", md6: "" } },
                                          [
                                            _c("v-autocomplete", {
                                              attrs: {
                                                clearable: "",
                                                label: _vm.formFields.sim.label,
                                                items: _vm.sim,
                                                "item-text": "simserienumero",
                                                "item-value": "simserienumero",
                                                disabled: _vm.isView
                                              },
                                              model: {
                                                value: _vm.formFields.sim.value,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.formFields.sim,
                                                    "value",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "formFields.sim.value"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ])
            ],
            1
          )
        ],
        1
      ),
      _c("app-confirmacion", {
        attrs: {
          show: _vm.dialogConfirmacion,
          titulo: _vm.$t("mensajes.crud.editar.titulo", {
            entidad: "Módulo"
          }),
          mensaje: _vm.mensajeConfirmacion,
          textoBtnSi: _vm.$t("mensajes.crud.editar.btnAceptar"),
          textoBtnNo: _vm.$t("mensajes.crud.editar.btnCancelar")
        },
        on: {
          modalConfirmationEmit: function($event) {
            return _vm.confirmCallback($event)
          }
        }
      }),
      _c("app-confirmacion", {
        attrs: {
          show: _vm.dialogConfirmacionClose,
          titulo: _vm.$t("mensajes.mensajesAbandono.editar.titulo"),
          mensaje: _vm.$t("mensajes.mensajesAbandono.editar.mensaje"),
          textoBtnSi: _vm.$t("mensajes.mensajesAbandono.editar.btnAceptar"),
          textoBtnNo: _vm.$t("mensajes.mensajesAbandono.editar.btnCancelar")
        },
        on: {
          modalConfirmationEmit: function($event) {
            return _vm.confirmCallbackConfirm($event)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }